import { LineItemSelector } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const ItemsToSplit = ({ lineItems, selectedItemsIds, onToggleItem }) => {
  return (
    <Styles.Container>
      {lineItems?.map((item, index) => (
        <LineItemSelector
          key={item.id}
          lineItem={{ ...item, productIndex: index + 1 }}
          selected={selectedItemsIds?.includes(item.id)}
          onClick={() => onToggleItem(item.id)}
          clickable
          showToggle
          showIndex
        />
      ))}
    </Styles.Container>
  )
}

export default ItemsToSplit
